import { render, staticRenderFns } from "./VisionPendingAlert.vue?vue&type=template&id=48c06a07&scoped=true"
import script from "./VisionPendingAlert.vue?vue&type=script&lang=js"
export * from "./VisionPendingAlert.vue?vue&type=script&lang=js"
import style0 from "./VisionPendingAlert.vue?vue&type=style&index=0&id=48c06a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c06a07",
  null
  
)

export default component.exports